import { AxiosResponse } from 'axios';
import { DocumentMarriageFormVM } from 'civil-status/view-models/document-birth-form';
import { DocumentMarriageVM } from 'civil-status/view-models/document-marriage-list';
import { DateTime } from 'luxon';
import { DocumentMarriageCM } from 'shell/models/document-marriage';
import { HttpResponse } from 'shell/models/http-response';

export const transformDocumentMarriage = (
  response: AxiosResponse<HttpResponse<DocumentMarriageCM>>,
  chosenDocument?: DocumentMarriageVM | null
): DocumentMarriageFormVM => {
  const payloadResponse = response.data?.payload;

  const item: DocumentMarriageFormVM = {
    indicatorUpdate:
      payloadResponse?.datiAttoMatrimonio?.flagAggiornato === '0' ||
      !payloadResponse?.datiAttoMatrimonio?.flagAggiornato
        ? 'È necessario effettuare la convalida dei dati.'
        : '',
    marriageDate: payloadResponse?.datiAttoMatrimonio?.dataMatrimonio
      ? DateTime.fromISO(payloadResponse?.datiAttoMatrimonio?.dataMatrimonio)
      : null,
    marriageMunicipality: payloadResponse?.datiAttoMatrimonio?.comuneMatrimonio || '',
    matricolaHusband: payloadResponse?.datiAttoMatrimonio?.matricolaMarito?.toString() || '',
    surnameHusband: payloadResponse?.datiAttoMatrimonio?.cognomeMarito || '',
    nameHusband: payloadResponse?.datiAttoMatrimonio?.nomeMarito || '',
    genderHusband: payloadResponse?.datiAttoMatrimonio?.sessoMarito || '',
    municipalityBirthHusband: payloadResponse?.datiAttoMatrimonio?.comuneNascitaMarito || '',
    residenceMunicipalityHusband: payloadResponse?.datiAttoMatrimonio?.comuneResidenzaMarito || '',
    citizenshipHusband: payloadResponse?.datiAttoMatrimonio?.cittadinanzaMarito || '',
    birthdayHusband: payloadResponse?.datiAttoMatrimonio?.dataNascitaMarito
      ? DateTime.fromISO(payloadResponse?.datiAttoMatrimonio?.dataNascitaMarito)
      : null,
    yearsHusband: payloadResponse?.datiAttoMatrimonio?.anniMarito?.trim() || '',
    yearDateHusband: payloadResponse?.datiAttoMatrimonio?.annoNascitaMarito || '',
    statusHusband: payloadResponse?.datiAttoMatrimonio?.statoCivileMarito || '',
    surnameAfterMarriageHusband:
      payloadResponse?.datiAttoMatrimonio?.cognomeDopoMatrimonioMarito || '',
    matricolaWife: payloadResponse?.datiAttoMatrimonio?.matricolaMoglie?.toString() || '',
    surnameWife: payloadResponse?.datiAttoMatrimonio?.cognomeMoglie || '',
    nameWife: payloadResponse?.datiAttoMatrimonio?.nomeMoglie || '',
    genderWife: payloadResponse?.datiAttoMatrimonio?.sessoMoglie || '',
    municipalityBirthWife: payloadResponse?.datiAttoMatrimonio?.comuneNascitaMoglie || '',
    residenceMunicipalityWife: payloadResponse?.datiAttoMatrimonio?.comuneResidenzaMoglie || '',
    citizenshipWife: payloadResponse?.datiAttoMatrimonio?.cittadinanzaMoglie || '',
    birthdayWife: payloadResponse?.datiAttoMatrimonio?.dataNascitaMoglie
      ? DateTime.fromISO(payloadResponse?.datiAttoMatrimonio?.dataNascitaMoglie)
      : null,
    yearsWife: payloadResponse?.datiAttoMatrimonio?.anniMoglie?.trim() || '',
    yearDateWife: payloadResponse?.datiAttoMatrimonio?.annoNascitaMoglie || '',
    statusWife: payloadResponse?.datiAttoMatrimonio?.statoCivileMoglie || '',
    surnameAfterMarriageWife:
      payloadResponse?.datiAttoMatrimonio?.cognomeDopoMatrimonioMoglie || '',
    registerNumber:
      payloadResponse?.datiAttoMatrimonio?.numeroRegistro || chosenDocument?.numReg || '',
    documentNumber:
      payloadResponse?.datiAttoMatrimonio?.numeroAtto || chosenDocument?.documentNumber || '',
    portion: payloadResponse?.datiAttoMatrimonio?.parte || chosenDocument?.parte || '',
    serie: payloadResponse?.datiAttoMatrimonio?.serie1?.trim() || chosenDocument?.serie || '',
    serie2: payloadResponse?.datiAttoMatrimonio?.serie2?.trim() || chosenDocument?.serie2 || '',
    year: payloadResponse?.datiAttoMatrimonio?.anno || chosenDocument?.year || '',
    uploadFile:
      payloadResponse?.attoMatrimonioCM?.attoByteArray && payloadResponse?.attoMatrimonioCM?.atto
        ? {
            raw:
              payloadResponse?.attoMatrimonioCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
            rawTiff: `data:image/png;base64,${payloadResponse?.attoMatrimonioCM?.attoByteArray}`,
            file: new File(
              payloadResponse?.attoMatrimonioCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
              payloadResponse?.attoMatrimonioCM?.nomeFile
            ),
          }
        : undefined,
    annotationInternationalList:
      payloadResponse?.annotazioniAttoMatrimonioInt?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
    annotationNationalList:
      payloadResponse?.annotazioniAttoMatrimonioNaz?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
  };
  return item;
};

export const transformDocumentMarriageRequestUpdate = (values: DocumentMarriageFormVM) =>
  ({
    coniuge1: {
      key: {
        numeroAtto: values.documentNumber || undefined,
        numeroRegistro: values.registerNumber || undefined,
        parte: values.portion || undefined,
        serie1: values.serie || undefined,
        serie2: values.serie2 || ' ',
        anno: values.year || undefined,
      },
      dataMatrimonio: values.marriageDate ? values.marriageDate?.toFormat('yyyy-MM-dd') : undefined,
      comuneMatrimonio: values.marriageMunicipality || undefined,
      matricola: values.matricolaHusband || undefined,
      cittadinanza: values.citizenshipHusband || undefined,
      cognome: values.surnameHusband || undefined,
      nome: values.nameHusband || undefined,
      sesso: values.genderHusband || undefined,
      comuneNascita: values.municipalityBirthHusband || undefined,
      comuneResidenza: values.residenceMunicipalityHusband || undefined,
      dataNascita: values.birthdayHusband
        ? values.birthdayHusband?.toFormat('yyyy-MM-dd')
        : undefined,
      anni: values.yearsHusband || undefined,
      annoNascita: values.yearDateHusband || undefined,
      statoCivile: values.statusHusband || undefined,
      cognomeDopoMatrimonio: values.surnameAfterMarriageHusband || undefined,
    },
    coniuge2: {
      key: {
        numeroAtto: values.documentNumber || undefined,
        numeroRegistro: values.registerNumber || undefined,
        parte: values.portion || undefined,
        serie1: values.serie || undefined,
        serie2: values.serie2 || ' ',
        anno: values.year || undefined,
      },
      dataMatrimonio: values.marriageDate ? values.marriageDate?.toFormat('yyyy-MM-dd') : undefined,
      comuneMatrimonio: values.marriageMunicipality || undefined,
      cittadinanza: values.citizenshipWife || undefined,
      matricola: values.matricolaWife || undefined,
      cognome: values.surnameWife || undefined,
      nome: values.nameWife || undefined,
      sesso: values.genderWife || undefined,
      comuneNascita: values.municipalityBirthWife || undefined,
      comuneResidenza: values.residenceMunicipalityWife || undefined,
      dataNascita: values.birthdayWife ? values.birthdayWife?.toFormat('yyyy-MM-dd') : undefined,
      anni: values.yearsWife || undefined,
      annoNascita: values.yearDateWife || undefined,
      statoCivile: values.statusWife || undefined,
      cognomeDopoMatrimonio: values.surnameAfterMarriageWife || undefined,
    },
  } as const);
